import * as React from 'react';

const ProjectBlockChart = (props) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={59} height={59} viewBox='0 0 59 59' {...props}>
    <g id='graph' transform='translate(-2 -2)'>
      <rect
        id='Rectangle_1777'
        data-name='Rectangle 1777'
        width={17}
        height={26}
        rx={1}
        transform='translate(2 35)'
        fill='#fff'
      />
      <rect
        id='Rectangle_1778'
        data-name='Rectangle 1778'
        width={17}
        height={42}
        rx={1}
        transform='translate(44 19)'
        fill='#fff'
      />
      <rect
        id='Rectangle_1779'
        data-name='Rectangle 1779'
        width={17}
        height={59}
        rx={1}
        transform='translate(23 2)'
        fill='#fff'
      />
    </g>
  </svg>
);
export default ProjectBlockChart;
